import React, { useState, useEffect } from "react";
import { Truck, ShieldCheck, RotateCcw, Clock, Phone, Mail, Menu, X, MessageCircle } from "lucide-react";
import { company, navLinks } from "../mock";
import { usePreventivo } from "./PreventivoContext";

const Announcement = () => (
  <div className="bg-[#e8464a] text-white text-[13px] font-medium">
    <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center justify-center gap-x-6 gap-y-1 text-center">
      <span className="flex items-center gap-1.5"><Truck size={15} /> <b className="font-bold">SPEDIZIONE GRATUITA</b> in tutta Italia</span>
      <span className="hidden sm:inline opacity-50">·</span>
      <span className="flex items-center gap-1.5"><ShieldCheck size={15} /> <b className="font-bold">GARANZIA 12-24 MESI</b></span>
      <span className="hidden sm:inline opacity-50">·</span>
      <span className="flex items-center gap-1.5"><RotateCcw size={15} /> Soddisfatti o rimborsati - Reso 14gg</span>
    </div>
  </div>
);

const ContactBar = () => (
  <div className="bg-[#0f2846] text-white/80 text-[13px]">
    <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center justify-center gap-x-6 gap-y-1">
      <span className="flex items-center gap-1.5"><Clock size={14} /> {company.hours}</span>
      <a href={`tel:+39${company.phones[0].raw}`} className="flex items-center gap-1.5 hover:text-white transition-colors"><Phone size={14} /> {company.phones[0].display}</a>
      <a href={`mailto:${company.email}`} className="flex items-center gap-1.5 hover:text-white transition-colors"><Mail size={14} /> {company.email}</a>
    </div>
  </div>
);

const Logo = () => (
  <a href="#top" className="flex items-center gap-3">
    <div className="w-11 h-11 rounded-lg bg-[#0f2846] text-white flex items-center justify-center font-display font-bold text-lg tracking-wide">{company.logoInitials}</div>
    <div className="leading-tight">
      <div className="font-display font-bold text-[#0f2846] text-[15px] sm:text-base uppercase">{company.name}</div>
      <div className="text-[10px] tracking-[0.2em] text-slate-400 font-semibold">{company.logoSubtitle}</div>
    </div>
  </a>
);

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { openPreventivo } = usePreventivo();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header id="top" className="sticky top-0 z-50">
      <Announcement />
      <ContactBar />
      <div className={`bg-white border-b border-slate-100 transition-shadow ${scrolled ? "shadow-md" : ""}`}>
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
          <Logo />
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((l) => (
              <a key={l.href} href={l.href} className="text-[15px] font-medium text-slate-700 hover:text-[#e8464a] transition-colors">{l.label}</a>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            <a href={company.whatsappLink} target="_blank" rel="noreferrer" className="hidden sm:flex items-center gap-2 bg-[#22c35e] hover:bg-[#1da851] text-white font-semibold text-sm px-4 py-2.5 rounded-lg transition-colors">
              <MessageCircle size={16} /> WhatsApp
            </a>
            <button onClick={() => openPreventivo()} className="hidden sm:inline-flex bg-[#0f2846] hover:bg-[#14345a] text-white font-semibold text-sm px-5 py-2.5 rounded-lg transition-colors">Preventivo</button>
            <button onClick={() => setOpen(!open)} className="lg:hidden p-2 text-[#0f2846]" aria-label="menu">
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
        {open && (
          <div className="lg:hidden border-t border-slate-100 bg-white px-4 py-4 flex flex-col gap-1">
            {navLinks.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="py-2.5 text-slate-700 font-medium border-b border-slate-50">{l.label}</a>
            ))}
            <div className="flex gap-2 mt-3">
              <a href={company.whatsappLink} target="_blank" rel="noreferrer" className="flex-1 text-center flex items-center justify-center gap-2 bg-[#22c35e] text-white font-semibold text-sm px-4 py-2.5 rounded-lg"><MessageCircle size={16} /> WhatsApp</a>
              <button onClick={() => { setOpen(false); openPreventivo(); }} className="flex-1 text-center bg-[#0f2846] text-white font-semibold text-sm px-4 py-2.5 rounded-lg">Preventivo</button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
